<template>
  <div>
    <el-breadcrumb class="breadcrumb-box" separator="/">
      <el-breadcrumb-item class="bread-text" v-for='(item,index) in breadcrumb()' :key='index'>
       
        <div v-if="item['requestUrl']" class="flex">
          {{$route.query.appName}}
          <div class="breadcrumb-select" :class="{'btnDisabled':breadcrumb().length>2}">
            {{item.appName}}
            <i class="el-icon-arrow-down"  :class="{'none':breadcrumb().length>2}"></i>
            <ul class="breadcrumb-select-list" id="breadcrumb-select-list">
              <li class="breadcrumb-select-item" v-for="(item,index) in breadcrumbSelect" :key="index" @click="onChange(item.id,item.appName)">
                {{ item.appName }}
              </li>
              <div class="border"></div>
            </ul>
          </div>
        </div>
        <div v-else>
          <div @click="(index+1 < breadcrumb.length ) && onNavigate(item)">
            {{item.name}}
          </div>
        </div>
      </el-breadcrumb-item>
    </el-breadcrumb>

  </div>
</template>

<script>
export default {
  watch: {
    breadcrumbStore(newValue, oldValue) {
      // 执行需要强制刷新的操作
      this.breadcrumb()
    }
  },
  computed: {
    breadcrumbStore(){
      return this.$store.getters["breadcrumbStore/getBreadcrumb"];
    },
  },
  data() {
    return {
      page: 1,
      perPage: 10000,
      total: 0,
      breadcrumbSelect:[],
    };
  },
  created() {
    this.scrollLoad();
  },
  mounted() {
    var element = document.getElementById('breadcrumb-select-list');
    if(element){
      element.onscroll = ()=> {
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
          if(this.total == this.breadcrumbSelect.length) return;
          this.page++;
          this.scrollLoad()
        }
      }
    }
  },  
  methods: {
    breadcrumb() {
      let arr = [];
      this.$route.meta.breadcrumb.forEach(item=>{
        arr.push(this.$store.getters["breadcrumbStore/keyGetBreadcrumb"](item))
      })
      // console.log(arr);
      return arr;
    },
    // 过滤面包屑(key是指路由的name)
    filter (key) {
      // 看看是否有去自定义处理面包屑，没有就递归选择对应路由的title
      if(this.$store.getters["breadcrumbStore/keyGetBreadcrumb"](key)){
        return this.$store.getters["breadcrumbStore/keyGetBreadcrumb"](key);
      }else{
        try {
          var routes = this.$router.options.routes;
          this.recursionGetRouterTitle(routes,key);
        } catch (error) {
          return JSON.parse(error.message)
        }
      }
    },
    // 递归获取路由对应的title
    recursionGetRouterTitle (arr,key) {
      arr.forEach(item=>{
        if(key == item.name){
          // console.log(item.fullPath)
          // console.log(this.$route.fullPath)
          throw new Error(JSON.stringify({
            name:item.meta.title,
            path:item.name,
          }));
          return
        }
        if(item['children']){
          this.recursionGetRouterTitle(item['children'],key)
        }
      })
    },
    //面包屑下拉框（目前只是写死了1个请求接口，后续有新的再封装）
    scrollLoad () {
      this.loading = true
      this.$apis.consoleSever
        .queryList()
        .then(res => {
          if (res.code == 0) {
            this.breadcrumbSelect = this.breadcrumbSelect.concat(res.data);
            this.total = res.data.total;
          }
        });
    },
    
    onNavigate(item) {
      // this.$router.push({
      //   name: item.path,
      //   query:this.$route.query
      // });
      window.location.href=item.path;
    },
    //创建链接
    onChange(id,appName){
      this.$router.replace({
        // path:this.$route.path,
        query:{
          appId:id,
          appName:appName,
        }
      });
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">

.breadcrumb-box{
  height: 40px;    
  padding: 20px 20px 0 20px;
  line-height: 20px;
  .bread-text{
    cursor: pointer;
  }
  /deep/ .el-breadcrumb__inner{
    max-width: 200px;
  }
  .breadcrumb-select{
    // width: 100px;
    position: relative;
    min-height:20px;
    cursor: pointer;
    .breadcrumb-select-list{
      //  width: 100px;
      display: none;
      position: absolute;
      top: 20px;
      left: -80px;
      // width: 110%;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      height: 200px;
      overflow-y: scroll;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      z-index: 10;
      .breadcrumb-select-item{
        font-size: 14px;
        width: 100px;
        padding: 0 10px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        &:hover{
          background-color: #f5f7fa;
        }
      }
      .border{
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent; 
        border-bottom: 6px solid #e4e7ed;  
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        &::before{
          position: absolute;
          top: -4px;
          left: 50%;
          transform: translate(-50%);
          content: '';
          border: 6px solid transparent; 
          border-bottom: 6px solid #fff;  
        }
      }
    }
    &:hover .breadcrumb-select-list{
      display: block;
    }
    
  }
  .btnDisabled:hover .breadcrumb-select-list {
    display: none;
  }
  .none{
    display: none;
  }
}
</style>
